<template>
  <div class="expanded-content pa-3">
    <div v-if="loading" class="text-center py-4">
      <v-progress-circular indeterminate color="primary" />
    </div>
    <div v-else-if="!productMatchings?.length" class="text-center py-4 text-grey">
      No matched product matchings found
    </div>
    <EnhancedDataTable
      v-else
      :items="productMatchings"
      :headers="headers"
      item-key="Product_Matching_SK"
      :showSelect="false"
      :showCrudActions="false"
      :showResetFilters="false"
      :showUnselectAll="false"
      :initialItemsPerPage="-1"
      :hideFooter="true"
      :hideTitle="true"
    >
      <template #item.actions="{ item }">
        <div class="justify-center" @click.stop>
          <v-btn
            icon
            size="x-small"
            variant="text"
            @click="handleReset(item)"
            title="Reset to Not Matched"
          >
            <v-icon size="small" color="warning">mdi-code-tags</v-icon>
          </v-btn>
        </div>
      </template>
    </EnhancedDataTable>
  </div>
</template>

<script>
import EnhancedDataTable from '@/components/EnhancedDataTable.vue'
import ALL_PRODUCT_MATCHINGS_BY_PRODUCT from '@/graphql/Product/allProductMatchingsByProduct.gql'
import RESET_PRODUCT_MATCHINGS from '@/graphql/Product/resetProductMatchings.gql'

export default {
  name: 'ProductMatchingsSubTable',
  components: { EnhancedDataTable },
  props: {
    productSk: { type: Number, required: true }
  },
  data() {
    return {
      loading: false,
      productMatchings: [],
      headers: [
        { title: '#', key: 'Product_Matching_SK', align: 'center' },
        { title: 'SKU ID', key: 'SKU_ID', align: 'left' },
        { title: 'SKU EAN', key: 'SKU_EAN', align: 'left' },
        { title: 'SKU Name', key: 'SKU_Name', align: 'left' },
        { title: 'Brand', key: 'Aggregated_Brand_Name', align: 'center' },
        { title: 'GR Fields', key: 'GR_Fields', sortable: false, align: 'left' },
        { title: 'EXT Info', key: 'EXT_Product_Info_JSON' },
        { title: 'Status', key: 'Matching_TS', align: 'center' },
        { title: 'Suggestions', key: 'Suggestions', sortable: false, align: 'left' },
        { title: 'Total USD', key: 'Total_Amount_USD', align: 'end' },
        { title: 'Log', key: 'Mutation_Logs_Count', sortable: false, align: 'center', width: '60px' },
        { title: 'Actions', key: 'actions', sortable: false, align: 'center', width: '80px' }
      ]
    }
  },
  async mounted() {
    await this.fetchProductMatchings()
  },
  methods: {
    async fetchProductMatchings() {
      this.loading = true
      try {
        const { data } = await this.$apollo.query({
          query: ALL_PRODUCT_MATCHINGS_BY_PRODUCT,
          variables: { Matched_Product_FK: this.productSk },
          fetchPolicy: 'network-only'
        })
        this.productMatchings = data.allProductMatchings || []
      } catch (error) {
        console.error('Error fetching product matchings:', error)
        this.productMatchings = []
      } finally {
        this.loading = false
      }
    },
    async handleReset(item) {
      try {
        await this.$apollo.mutate({
          mutation: RESET_PRODUCT_MATCHINGS,
          variables: { Product_Matching_SKs: [item.Product_Matching_SK] }
        })
        // Remove the item from local list (it's no longer matched to this product)
        this.productMatchings = this.productMatchings.filter(
          pm => pm.Product_Matching_SK !== item.Product_Matching_SK
        )
      } catch (error) {
        console.error('Error resetting product matching:', error)
      }
    }
  }
}
</script>

<style scoped>
.expanded-content {
  background-color: rgba(255, 255, 255, 0.08);
  border-left: 3px solid rgba(var(--v-theme-primary), 0.5);
  margin-left: 8px;
}

.expanded-content :deep(.v-data-table),
.expanded-content :deep(.v-table),
.expanded-content :deep(.v-table__wrapper),
.expanded-content :deep(table),
.expanded-content :deep(thead),
.expanded-content :deep(tbody),
.expanded-content :deep(tr),
.expanded-content :deep(th),
.expanded-content :deep(td) {
  background-color: transparent !important;
}

.expanded-content :deep(.v-card) {
  background-color: transparent !important;
}
</style>
